import React from 'react';
import { createRoot } from 'react-dom/client';
import LoginScreen from './LoginScreen';

const SDK = {
  openLoginScreen: (onLogin) => {
    //SDK를 생성할 root를 만들어 준다.
    const sdkRoot = document.createElement('div');
    sdkRoot.id = 'sdk-container'

    // Body에 루트를 만들어 주면서 일반 root와 같은 레벨에 위치
    document.body.appendChild(sdkRoot);

    //생성한 root에 필요한 화면을 그려준다.
    createRoot(document.getElementById('sdk-container')).render(
      <React.StrictMode>
        <LoginScreen onLogin={onLogin} />
      </React.StrictMode>
    );
  },
};


SDK.openLoginScreen();

export default SDK;
